var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "48px",
    viewBox: "0 0 100 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-KnowledgeBase",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KnowledgeBase-04---Search-No-results---Mobile",
    transform: "translate(-20.000000, -326.000000)",
    stroke: "#E1E2E4",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(22.000000, 328.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0555556,0 L70.4444444,0 C74.0649778,0 77,3.28324517 77,7.33333333 L77,36.6666667 C77,40.7167548 74.0649778,44 70.4444444,44 L24.5555556,44 C20.9350222,44 18,40.7167548 18,36.6666667 L18,7.33333333 C18,3.28324517 20.9350222,0 24.5555556,0 L40.9444444,0",
    id: "Rectangle-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,33.5 C40.2525068,31.5 43.9668622,30.5 47.6430664,30.5 C51.3001956,30.5 54.9191734,31.5 58.5,33.5",
    id: "Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(30.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14095449e-13,3.55271368e-14 L8,8",
    id: "Path-58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,3.55271368e-14 L7.14095449e-13,8",
    id: "Path-58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(56.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14095449e-13,3.55271368e-14 L8,8",
    id: "Path-58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,3.55271368e-14 L7.14095449e-13,8",
    id: "Path-58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92,14 L92,14 C94.4549974,16.0881048 96,19.12259 96,22.5 C96,25.87741 94.4549974,28.9118952 92,31",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,31 L4,31 C1.54500256,28.9118952 0,25.87741 0,22.5 C0,19.12259 1.54500256,16.0881048 4,14",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadRobot);
export default __webpack_public_path__ + "static/media/SadRobot.2139c042b78807264b18817773784e50.svg";
export { ForwardRef as ReactComponent };